/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_AppliedInputs */

const cs_addr_sugg_applied = /** @type {(inputs: Addr_Sugg_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa doplněna`)
};

const en_addr_sugg_applied = /** @type {(inputs: Addr_Sugg_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address completed`)
};

/**
* | output |
* | --- |
* | "Address completed" |
*
* @param {Addr_Sugg_AppliedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_applied = /** @type {((inputs?: Addr_Sugg_AppliedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_AppliedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_applied(inputs)
	return cs_addr_sugg_applied(inputs)
});